<template>
  <element>
    <AppBar :title="title" />
    <v-container class="pt-0">
      <div class="form-container">
        <v-row no-gutters class="d-flex justify-content-center">
          <v-icon class="page-icon pb-1 ml-2" color="#2e384d" size="64"
            >mdi-car-door</v-icon
          >
        </v-row>
        <p class="new-order-desc">
          {{ $t("enterNewPart_CarReg.description") }}
        </p>
        <form action="#" @submit.prevent="submit">
          <SearchTextField
            ref="partGroup"
            class="mt-2"
            :label="$t('enterNewPart_CarReg.partGroupLabel')"
            apiEndpoint="PartGroups"
            placeholder="Start typing a group name..."
            display_attribute="name"
            value_attribute="part_group_id"
            required
          ></SearchTextField>
          <SearchTextField
            ref="oemNumber"
            class="mt-2"
            :label="$t('enterNewPart_CarReg.oemNumberLabel')"
            apiEndpoint="Parts"
            placeholder="Start typing an oem number..."
            display_attribute="oem_number"
            value_attribute="part_id"
            required
          ></SearchTextField>
          <SearchTextField
            ref="partName"
            class="mt-2"
            :label="$t('enterNewPart_CarReg.partNameLabel')"
            apiEndpoint="Partnames"
            placeholder="Start typing..."
            display_attribute="name"
            value_attribute="part_id"
            required
          ></SearchTextField>
          <LabelTextArea
          ref="description"
          :label="$t('enterNewPart_CarReg.descriptionLabel')"
          class="mt-2"
          >
          </LabelTextArea>
          <v-btn
            class="submit-btn"
            height="45px"
            color="#033e8c"
            depressed
            block
            dark
            @click="complete"
          >
            {{ $t("enterNewPart_CarReg.addPartBtnTitle") }}
          </v-btn>

        </form>
      </div>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue";
import { DOCUMENT_TYPE_PART_PICTURE } from "@/constants";
import SearchTextField from "@/components/search/SearchTextField.vue"
import LabelTextArea from "@/components/common/LabelTextArea.vue"

export default {
  name: "EnterNewPartCarReg",
  props: {},
  components: {
    AppBar,
    SearchTextField,
    LabelTextArea
  },
  data() {
    return {
      title: "",
      valid: false,
      car_id: null,
      documentType: DOCUMENT_TYPE_PART_PICTURE,
      part_id: null,
      partGroupsList: null,
    };
  },
  methods: {

    async complete() {
      let oem_number = ''
      let name=''
      let part_group_name = ''
      let parent_id = null

      const taskId = this.$store.getters.getCurrentTask?.id;
      if (taskId) {
        // create a part
        const formData = new FormData();


        oem_number = this.$refs.oemNumber.selectedSearchResult ? this.$refs.oemNumber.selectedSearchResult.oem_number : this.$refs.oemNumber.text
        name = this.$refs.partName.selectedSearchResult ? this.$refs.partName.selectedSearchResult.name : this.$refs.partName.text
        part_group_name = this.$refs.partGroup.selectedSearchResult ? this.$refs.partGroup.selectedSearchResult.name : this.$refs.partGroup.text

        // test here is we don't have that group existing already in database

        const response3 = await this.axios.get("/PartGroups/get?car_id=" + this.car_id)
        this.partGroupsList = response3.data.data
        console.log("partGroup list", this.partGroupsList)
        
        let partGroupAlreadyExist = this.partGroupsList.find(o => o.name === part_group_name);
        if (partGroupAlreadyExist == null) {
            const formData2 = new FormData();

            formData2.append("car_id", this.car_id);
            formData2.append("name", part_group_name);

            const response2 = await this.axios.post("/PartGroups/add", formData2)
            if (response2.data != null) {
              console.log(response2.data)
              parent_id = response2.data.part_group_id
            }
        } else {
          parent_id = partGroupAlreadyExist.part_group_id
        }
        
        formData.append("car_id", this.car_id);
        formData.append("name", name);
        formData.append("parent_id", parent_id);
        formData.append("description", this.$refs.description.textValue);
        formData.append("oem_number", oem_number);
        formData.append("physical_location", "IN_CAR");
        
        const response = await this.axios.post("/Parts/put", formData)
        this.part_id = response.data.part_id

        const variables = {
        "variables": {
          "part_id":{
            "value":this.part_id,
            "type":"Integer"
          }
         }
        }

        this.$store
          .dispatch("completeTask", {
            taskId,
            variables
          })
          .then((response) => {
            console.log("Task completed successfully!", taskId, response);
          })
          .catch((error) => {
            console.log("Failed completing task!", taskId, error);
          })
          .finally(() => {
            console.log("Finally completing task!");
          });
      }
    },
    getPartGroupList(car_id){
      return fetch(`/api/v1/PartGroups/get?car_id=${car_id}`, { method: 'GET' })
        .then(response => response.json())
        .then(json => json.data); 
    },

  },
  created() {
    this.title = this.$store.getters.getCurrentTask.taskName;
    const pid = this.$store.getters.getCurrentPID;
    /*
    this.$refs.partName.textValue = "";
    this.$refs.oemNumber.textValue = "";
    this.$refs.car_make_id.textValue = "";
    this.$refs.car_model_id.textValue = "";
    this.$refs.quantity.numberInput = 1;
   */
    this.$store
      .dispatch("retrieveProcessVariables", pid)
      .then((response) => {
        try {
          this.car_id = parseInt(response.data.data.car_id.value);
        } catch (error) {
          console.log("Failed retrieving variables from API.", error);
        }
      })
      .catch((error) => {
        console.log("Failed retrieving variables from API", error);
      });
  },
};
</script>

<style scoped>
/*
.parts-list {
  position: absolute;
  top: 60px;
  left: 16px;
  background-color: white;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  z-index: 999;
  padding: 5px;
  min-height: 35px;
  transition: width 0.3s;
}

.part-list-collapsed {
  height: 35px;
  width: 120px;
  overflow: hidden;
}
.part-list-expanded {
  height: auto;
  width: 350px;
}

@media screen and (max-width: 376px) {
  .part-list-expanded {
    width: 90%;
  }
}

.part-list-collapsed .part-list-toggle-btn > .part-list-close {
  display: none;
}

.part-list-collapsed .part-list-toggle-btn > .part-list-chevron-down {
  display: inherit;
}

.part-list-expanded .part-list-toggle-btn > .part-list-chevron-down {
  display: none;
}

.part-list-expanded .part-list-toggle-btn > .part-list-close {
  display: inherit;
}

.part-count-badge {
  height: 20px;
  min-height: 20px;
  min-width: 20px;
  background: #4caf50;
  border-radius: 20px;
  color: white;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  padding: 4px;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  line-height: 12px;
}

.part-list-label {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 100%;
  display: inline-block;
  color: #000000;
}

.part-list-toggle-btn > .v-icon {
  color: grey !important;
  font-size: 16px;
}

.part-item-picture {
  height: 45px;
  width: 45px;
  object-fit: cover;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.part-item-oem-number {
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 100%;
  color: rgba(0, 0, 0, 0.63);
}

.part-item-name {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 100%;
  color: #000000;
  text-overflow: ellipsis;
}

.part-item-delete-icon {
  height: auto;
  text-align: right;
}

.part-item-delete-icon > i {
  width: 10px;
  color: red !important;
}

.part-item {
  border-top: 1px solid lightgray;
  text-align: left !important;
}

.part-list-group {
  max-height: 400px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

.parts-list.part-list-collapsed .part-list-group {
  display: none;
}

.new-order-desc {
  margin-top: 1.375rem;
  margin-bottom: 2.1875vh !important;
  font-size: 0.875rem;
  font-weight: lighter;
  color: #2e384d;
}
*/

.finish-btn {
  margin-top: 24px;
}
.form-container {
  padding: 0 8px;
}
/*
.another_part {
  margin-top: 18px;
}
*/
</style>
